var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRectangle3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "431px",
    height: "375px",
    viewBox: "0 0 431 375",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Rectangle3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.02007121,363.737916 L115.329572,6.0834933 C116.674663,1.874941 121.17678,-0.446353549 125.385332,0.898736804 C126.221138,1.16586783 127.007304,1.56868252 127.712335,2.09104425 L427.264655,224.031043 C430.814714,226.661302 431.56036,231.671439 428.930101,235.221499 C427.943959,236.552494 426.568961,237.544548 424.994921,238.06071 L11.1330998,373.775134 C6.93478771,375.151854 2.41533186,372.864501 1.03861267,368.666188 C0.513978051,367.066313 0.507489584,365.341694 1.02007121,363.737916 Z",
    id: "Rectangle3",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectangle3);
export default __webpack_public_path__ + "static/media/Rectangle3.327c6a7b9fc23a47537d653344b784d5.svg";
export { ForwardRef as ReactComponent };